class ContactUsForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('#ContactForm');
        this.thankYou = this.querySelector('.contact-us-thank-you');
        this.submitButton = this.form.querySelector('button[type="submit"]');
        this.container = this.querySelector('.contact-us-container');
        
        this.init();
        this.checkUrlParams();
    }

    init() {
        this.form.addEventListener('input', this.handleInput.bind(this));
    }

    checkUrlParams() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('contact_posted') === 'true') {
            this.showThankYou();
        }
    }

    handleInput() {
        const name = this.form.querySelector('#ContactForm-name').value;
        const email = this.form.querySelector('#ContactForm-email').value;
        const message = this.form.querySelector('#ContactForm-body').value;
        
        this.submitButton.disabled = !(name && email && message);
    }

    showThankYou() {
        this.container.style.display = 'none';
        this.thankYou.style.display = 'block';
    }
}

customElements.define('contact-us-form', ContactUsForm);